import { render, staticRenderFns } from "./e-commerce.vue?vue&type=template&id=d55f5424&scoped=true&"
import script from "./e-commerce.vue?vue&type=script&lang=js&"
export * from "./e-commerce.vue?vue&type=script&lang=js&"
import style0 from "./e-commerce.vue?vue&type=style&index=0&id=d55f5424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f5424",
  null
  
)

export default component.exports